export default class AnimeNotFoundException extends Error {

}